import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { BriefingStepItem } from '@/shared/briefing'
import type { RohsBriefingStep } from '../../utils/rohsLegislationBriefing'
import { ROHS_BRIEFING_ID_PREFIX } from './constants'
import { toV2RohsBriefingStep } from './toV2RohsBriefingStep'

export function V2RohsLegislationBriefingStepShell({
  step,
  index,
  actions,
  children,
}: {
  step: RohsBriefingStep
  index: number
  actions?: ReactNode
  children?: ReactNode
}) {
  const { t } = useTranslation('common')

  return (
    <BriefingStepItem
      idPrefix={ROHS_BRIEFING_ID_PREFIX}
      index={index}
      step={toV2RohsBriefingStep(step, t)}
      actions={actions}
    >
      {children}
    </BriefingStepItem>
  )
}
